import type React from "react";

import { faUserCog } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useProfileContext } from "contexts/ProfileContext";
import { WidgetBox } from "shared/containers/WidgetBox";
import { hasHCO } from "utils/profile/profileHelper";

import { AppointmentScheduledNotificationSwitch } from "../AppointmentScheduledNotificationSwitch";
import { AvailableToSubstituteSwitch } from "../AvailableToSubstituteSwitch";
import { NewPatientNotificationSwitch } from "../NewPatientNotificationSwitch";
import { WeeklyPatientLimit } from "../WeeklyPatientLimit";

export const PatientPreferences: React.FC = () => {
  const { t } = useTranslation();
  const { profile } = useProfileContext();
  const weeklyPatientLimitEnabled: boolean =
    !hasHCO(profile) &&
    !!profile?.therapist_profile?.feature_flags?.includes("WEEKLY_PATIENT_ASSIGNMENT_LIMIT") &&
    !profile?.therapist_profile?.feature_flags?.includes("BOOKING_V2");
  const newPatientNotificationEnabled: boolean =
    profile?.therapist_profile?.feature_flags?.includes("IGNORE_NEW_PATIENTS_EMAIL_TOGGLE") || false;

  return (
    <WidgetBox
      data-testid="patient-preferences-container"
      icon={<FontAwesomeIcon icon={faUserCog} />}
      title={t("settings.patient_settings")}
      color="blue"
    >
      <Stack>
        {newPatientNotificationEnabled && <NewPatientNotificationSwitch />}

        <AppointmentScheduledNotificationSwitch />

        <AvailableToSubstituteSwitch />

        {weeklyPatientLimitEnabled && <WeeklyPatientLimit />}
      </Stack>
    </WidgetBox>
  );
};
